import type { FrozenAccountsTablePrefs } from './useFrozenAccountsTablePrefs';

type FrozenTablePrefs = FrozenAccountsTablePrefs['table'];

export interface AccountsTablePrefsHydrationTarget {
  setSortBy: (sortBy: FrozenTablePrefs['sortBy']) => void;
  setAllFilters: (filters: FrozenTablePrefs['filters']) => void;
  setPageSize: (pageSize: FrozenTablePrefs['pageSize']) => void;
  setGlobalFilter?: (globalFilter: FrozenTablePrefs['globalFilter']) => void;
  gotoPage: (pageIndex: FrozenTablePrefs['pageIndex']) => void;
}

/** Restores sort/page from saved prefs and column filters from in-tab memory. */
export const hydrateAccountsTablePrefs = (
  tableData: AccountsTablePrefsHydrationTarget,
  tablePrefs: FrozenTablePrefs,
  withGlobalFilter: boolean,
  sessionFilters?: {
    filters?: FrozenTablePrefs['filters'];
    globalFilter?: string;
  }
): void => {
  tableData.setSortBy(tablePrefs.sortBy);
  tableData.setAllFilters(sessionFilters?.filters ?? []);
  tableData.setPageSize(tablePrefs.pageSize);
  if (withGlobalFilter && typeof tableData.setGlobalFilter === 'function') {
    tableData.setGlobalFilter(sessionFilters?.globalFilter ?? '');
  }
  tableData.gotoPage(tablePrefs.pageIndex);
};
